import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
// import Wrp from '../../../hoc/Wrp/Wrp';
// import ToolTipWrapper from '../../../../hoc/Wrp/ToolTipWrapper';
class HtmlPreviewData extends Component {
  
  componentDidMount(){
      // console.log(this.props);
  }
  render () {
    const {colData,id} = this.props;
    const eventsHandler = {
      onClick:() => (colData.clickHandler) ?
              colData.clickHandler():
                    'javascript(void)'
    }
    const access_mode = (colData.access_mode==undefined)? true:colData.access_mode;
    // console.log(colData);
      return(
          <td key={"column"+this.props.id}>
            {(access_mode==true)? 
              <a {...eventsHandler} >
                {colData.value}
              </a>
            :''}
            
          </td>
      );
  }
}

export default HtmlPreviewData;